export default "/assets/images/mila-air-mini.566ec12cb9dfda50.jpg";